import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Form } from '../../entities/forms/form';
import { environment } from "../../../../environments/environment";
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  apiURL = environment.apiUrl;

  constructor(private http: HttpClient) { }
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  getUsers(): Observable<Form> {
    return this.http.get<Form>(this.apiURL + '/getUsuarioRealgisTodos')
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  assignFormUser(form_user: any){
    return this.http
    .post(this.apiURL + "/formulario_usuario/0", form_user)
    .pipe(retry(1), catchError(this.handleError));

  }

  createNewUser(user: any){
return this.http
    .post(this.apiURL + "/getUsuarioRealgis_Rol", user)
    .pipe(retry(1), catchError(this.handleError));
  }

  getUser(idUser){
return this.http.get<Form>(this.apiURL + '/usuario_realgis/' + idUser)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  editUser(user: any){
    console.log(user);
return this.http
    .post(this.apiURL + "/getUsuarioRealgisActualiza", user)
    .pipe(retry(1), catchError(this.handleError));
  }
  
disableUser(user: any){
  return this.http
    .post(this.apiURL + "/getUsuarioRealgisInhabilita", user)
    .pipe(retry(1), catchError(this.handleError));
}

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code (form): ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }


}
